module.exports = __webpack_public_path__ + "img/ca-flag.a0979f79.png";